import { ValidationFn } from './useValidation';
export class ValidationUtils {
  private constructor() {}

  /**
   * Combines multiple validation functions into one.
   * @param fns an array of validation functions, returning `undefined` if validation passes, and returning
   * a string or an non-empty array of strings if validation fails.
   *
   * @example
   * const x = 4;
   *
   * const xIs4 = () => {
   *   if(x !== 4) {
   *     return 'X is not 4.';
   *   }
   * }
   *
   * const xIsBiggerThan = (num: number) => {
   *   return () => {
   *     if(x <= num) {
   *       return `X is not bigger than ${num}.`;
   *     }
   *   }
   * }
   *
   * comst combined = combine([xIs4, xIsBiggerThan(20)]);
   * const validation = useValidation(combined);
   * // => { valid: false, errors: ['X is not bigger than 20.'] }
   *
   */
  public static combine(fns: Array<ValidationFn>): ValidationFn {
    return t => {
      const errors: Array<string> = [];
      for (const fn of fns) {
        const validateResult = fn(t);
        if (!validateResult) continue;
        const fnErrors = Array.isArray(validateResult) ? validateResult : [validateResult];
        errors.push(...fnErrors);
      }
      return errors;
    };
  }
}